
const initialState = {
    audits: [],
    surveys: [],
    survey_templates: [],
    audited_departments: [],
    audit_templates: [],
    findings: [],
    findingsScopeKey: null,
    question: [],
    question_comments:[],
};

export default function assetReducer(state = initialState, action) {
    switch (action.type) {

        case "GET_AUDITS":

            return {
                ...state,
                audits: action.payload,
            };

        case "GET_AUDIT_TEMPLATES":
            //console.log("GET_AUDIT_TEMPLATES ", action)
            return {
                ...state,
                audit_templates: action.payload,
            };

        case "FINDINGS_BY_SURVEY_REQUEST": {
            const nextKey = `survey:${action.survey_id ?? 0}`;
            const isScopeChange = nextKey !== state.findingsScopeKey;
            return {
                ...state,
                findings: isScopeChange ? [] : state.findings,
                findingsScopeKey: nextKey,
            };
        }

        case "FINDINGS_BY_SURVEY_SET":
            if (
                action.scopeKey != null &&
                state.findingsScopeKey != null &&
                action.scopeKey !== state.findingsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                findings: action.payload,
                findingsScopeKey: action.scopeKey ?? state.findingsScopeKey,
            };
        
        case "DELETE_AUDIT_SUCCESS":
            return {
                ...state,
                audits: state.audits.filter((a) => a.audit_id !== action.audit_id),
                surveys: state.surveys.filter((s) => s.audit_id !== action.audit_id),
            };

        case "GET_SURVEYS":
            //console.log(" GET_SURVEYS ", action)
            return {
                ...state,
                surveys: action.payload,
            };

        case "GET_SURVEYS_TEMPLATE":
           
            return {
                ...state,
                survey_templates: action.payload,
            };

        case "GET_AUDIT_DEPARTMENTS":
            return {
                ...state,
                audited_departments: action.payload,
            };

        case "CLEAR_SURVEY_QUESTION":
            return {
                ...state,
                question: null,
                question_comments: [],
            };

        case "GET_SURVEY_QUESTION_BY_ID":

            return {
                ...state,
                question: action.payload.data,
                question_comments:  action.payload.comments
            };

        case "EDIT_SURVEY_QUESTION_SUCCESS": {
            const qid = Number(action.payload?.question_id);
            const checklist = action.payload?.data?.checklist;
            if (
                state.question &&
                Number(state.question.question_id) === qid &&
                Array.isArray(checklist)
            ) {
                return {
                    ...state,
                    question: { ...state.question, checklist },
                };
            }
            return state;
        }

        default:
            return state;
    }
}